import styled from "styled-components";

export const LiveCasinoGridItemThumbnailDefaultBox = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; // keeps a 16:9 ratio
  overflow: hidden;
`;